import { AxiosResponse, AxiosError } from "axios";
import { prepareError } from "../../../utils/error";
import api from "../../../data/api";
import { OptionCl } from "../../../components/select-cl";
import { Dispatch } from "redux";


export const CITY_DOMAIN = "CITY"

export type City = {
    city: string
}

const prepareCtites  = ( response : City[]   ) => {
    const opts: OptionCl[] = response.map( (city : City) => ({
        id : city.city,
        description: city.city
    })
    )
    return opts;
}


// cities for the dropdown
export const fetchCities = (
    dispatch : Dispatch<any>,
    componentType: "CcbCriteria" 
) => {
    //console.log("ismag criteria service getting data from /cities")
    api
        .post("/codelist/v1/ccb/cities")
        .then( (response:AxiosResponse) => {

            if (response.data && response.data.result === "ERROR") {
                dispatch({ type: componentType + "/FETCHERROR", payload: prepareError(response.data) })
            } else { 
                //console.log("city domain service: got data " + JSON.stringify(response))
                const cities : City[] = response.data.CCB; 
                dispatch({type: componentType + "/DOMAINLOADED", payload: prepareCtites(cities), domain: CITY_DOMAIN })
            }
        }).catch( (error:AxiosError) => {
            dispatch({ type: componentType + "/FETCHERROR", payload: prepareError(error) })
        })

}
